import type { KnowledgeSyncTimeEnum } from '@shared/api';

export const KNOWLEDGE_SYNC_PERIODS: KnowledgeSyncTimeEnum[] = [
  'EVERY_4_HOURS',
  'EVERY_12_HOURS',
  'EVERY_DAY',
  'EVERY_3_DAYS',
  'EVERY_WEEK',
  'EVERY_MONTH',
  'DISABLE',
];
